import React from 'react';
import PropTypes from 'prop-types';
import SMConst from 'lib/SMConst';
import SMReservationHelper from 'components/helpers/SMReservationHelper';
import sprintf from 'sprintf';

class SMReservationStatusDescriptionView extends React.Component {

  constructor(props) {
    super(props);
  }

  getPaymentDescription() {
    let description = "";
    const reservation = this.props.reservation;
    const paymentLink = (<a href={Routes.payment_flow_about_index_path()} target="_blank">お支払いについて</a>);

    if (!reservation.billing) return "";
    if (reservation.status === SMConst.ReservationStatus.Postpay) {
      description = (<p><span dangerouslySetInnerHTML={{__html: sprintf(I18n.t('dashboard.text_000054'), Routes.dashboard_settings_contact_path(), Routes.dashboard_settings_account_path())}} />{paymentLink}</p>);
    } else if (reservation.status === SMConst.ReservationStatus.CancelSent && reservation.billing.payment_method === SMConst.PaymentMethod.Postpay) {
      description = (<p>{I18n.t('dashboard.text_000055')}{paymentLink}</p>);
    } else if (reservation.status === SMConst.ReservationStatus.CancelSent && reservation.billing.payment_method !== SMConst.PaymentMethod.Postpay) {
      description = (<p>{I18n.t('dashboard.text_000056')}</p>);
    } else if (reservation.status === SMConst.ReservationStatus.Refunded && reservation.billing.payment_method === SMConst.PaymentMethod.Postpay) {
      description = (<p>{I18n.t('dashboard.text_000057')}{paymentLink}</p>);
    } else if (reservation.status === SMConst.ReservationStatus.Refunded && reservation.billing.payment_method !== SMConst.PaymentMethod.Postpay) {
      description = (<p>{I18n.t('dashboard.text_000058')}</p>);
    }

    return description;
  }

  renderUser() {
    const reservation = this.props.reservation;
    let description = "";
    if (SMReservationHelper.isCompletedReservation(reservation) && reservation.is_direct) {
      description = I18n.t('dashboard.reservation_status_description.user.paid_direct');
    } else {
      description = reservation.status_description;
    }

    const paymentDescription = this.getPaymentDescription();

    return (
      <p className="dashboard-content mt10 mb50">
        <span dangerouslySetInnerHTML={{__html:description}}></span>
        {paymentDescription}
      </p>
    );
  }

  renderOwner() {
    const reservation = this.props.reservation;
    let noticeDueDate = "";
    let postpayPaymentDate = "";
    if (reservation.due_date_for_approval) {
      noticeDueDate = (
        <p>
          <span className="message-strong">{sprintf(I18n.t('dashboard.text_000046'), reservation.due_date_for_approval, reservation.remining_days_for_approval)}</span>{I18n.t('dashboard.text_000047')}
        </p>
      );
    } else if (reservation.status == SMConst.ReservationStatus.Postpay) {
      postpayPaymentDate = (
        <p>{I18n.t('dashboard.text_000053')}<a href={Routes.payment_flow_owner_about_index_path()} target="_blank">お支払いについて</a></p>
      );
    }

    let description = "";
    if (SMReservationHelper.isCompletedReservation(reservation) && reservation.is_direct) {
      description = I18n.t('dashboard.reservation_status_description.owner.paid_direct');
    } else {
      description = reservation.status_description;
    }

    return (
      <p className="dashboard-content mt10 mb50">
        <span dangerouslySetInnerHTML={{__html: description}}></span>
        {noticeDueDate}
        {postpayPaymentDate}
      </p>
    );
  }

  render() {
    if (this.props.isOwner) {
      return this.renderOwner();
    } else {
      return this.renderUser();
    }
  }
}

SMReservationStatusDescriptionView.propTypes = {
  reservation: PropTypes.object,
  isOwner: PropTypes.bool
};

export default SMReservationStatusDescriptionView;



// WEBPACK FOOTER //
// ./app/javascript/components/dashboard/shared/SMReservationStatusDescriptionView.jsx